var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('h1',[_vm._v(_vm._s(_vm.$t('errors.pageNotFound')))]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/","flat":"","color":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('common.backToHome'))+" ")])],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9422f2c8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = null
// module chunks = 